module.exports = __webpack_public_path__ + "static/media/studio 6 side shot main area waiting art floor ceiling studio vibes.1280x720.da2d7cc6.webp";